module.exports = __webpack_public_path__ + "img/need_prepare_outline.ea630c53.svg";